module.exports = __webpack_public_path__ + "static/img/banner_recruit_01.e95a628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/join/banner_recruit_01.png
// module id = ivOc
// module chunks = 10